import ApiService from "../api";

export default class TipoPagamentoService extends ApiService {

    constructor() {
        super('/api/tipo-pagamentos')
    }

    listar() {
        return this.get("");
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}
